var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('qrcode-stream',{staticStyle:{"width":"100%","height":"100%"},on:{"decode":_vm.onDecode,"detect":_vm.onDetect}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eefff00","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Scan.vue
// module id = null
// module chunks = 